<ng-container *transloco="let t">
  <section class="content-categories">
    <div class="ui-title">
      <div class="title-content">
        @if (subsidiarySelector()) {
          <a class="ui-item-link" [routerLink]="['/sucursales/grupos']">
            <pxw-icon icon="back" />
          </a>
        }
        {{ t('categories.sectionTitle') }}
      </div>

      @if (productTagsWithQuantities().length > 0) {
        <pxw-button
          size="sm"
          [rounded]="true"
          color="theme2-contrast"
          (click)="onFilterProducts()"
          style="margin-left: 0.5em"
        >
          <pxw-icon icon="filter" />
          {{ t('productFiltersDialog.title') }}
        </pxw-button>
      }
    </div>
    <div #categoryList class="categories-wrapper" (scroll)="onScroll()">
      @let activeCategories = categories() | pxwActiveCategories;

      @if (activeCategories.length > 0) {
        <div class="category-list">
          @for (category of activeCategories; track category.id; let i = $index) {
            <pxw-category-list-item
              [id]="category.id"
              [name]="category.name"
              [active]="category.active"
              [image]="category.image"
              [imageSize]="500"
              [imageLoaderParams]="{ quality: 80 }"
              imageSizes="(min-width: 768px) 30vw, (min-width: 576px) 50vw, 100vw"
              [hideLabelInList]="category.hideLabelInList"
              [availability]="category.availability"
              [listIndex]="i"
              [scrollTarget]="categoryList"
              [detailRoute]="['./categoria', category.id]"
              [isAvailable]="category | pxwIsCategoryAvailable$ | async"
              [isCartDisabled]="isCartDisabled()"
              [maxDiscount]="categoryMaxDiscounts().get(category.id) ?? 0"
              [hasPromotion]="categoriesWithPromotions().has(category.id)"
              (clickNotAvailable)="displayAvailabilityForCategory($event)"
            />
          }
        </div>
      } @else {
        <div class="without-categories">
          <h6>{{ t('categories.emptyList') }}</h6>
        </div>
      }
    </div>
    <app-show-order></app-show-order>
  </section>

  <pxw-category-availability-dialog />

  @if (productTagsWithQuantities().length > 0) {
    <app-product-filters-dialog
      [tagsWithQuantities]="productTagsWithQuantities()"
      (selectedTagIdsChange)="onSelectedTags($event)"
    />
  }
</ng-container>
